import {
    FETCH_DELETE_PROJECTS_REQUEST,
    FETCH_DELETE_PROJECTS_SUCCESS,
    FETCH_DELETE_PROJECTS_FAILURE,
} from '../../actions/projects/delete-project-action';

const initialState = {
    removed: null,
    isLoading: false,
    error: null,
};

const CLEAR_DATA = "CLEAR_DATA";
const DeleteProjectReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case FETCH_DELETE_PROJECTS_REQUEST:
            return {
                ...state,
                isLoading: true,
                error: null,
            };
        case FETCH_DELETE_PROJECTS_SUCCESS:
            return {
                ...state,
                isLoading: false,
                removed: action.payload || true,
            };
        case FETCH_DELETE_PROJECTS_FAILURE:
            return {
                ...state,
                isLoading: false,
                error: action.payload,
            };
        case CLEAR_DATA:
            return {
                ...initialState
            };
        default:
            return state;
    }
};

export default DeleteProjectReducer;